export default {
	root: {
		minWidth: 32
	}
};
